export const BASE_RESEARCH_PATH = '/pharma/:population';
